import { css } from 'styled-components';

export default css`
  letter-spacing: 0;
  text-transform: capitalize;
`;
